import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function ProductoSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="w-full bg-white py-6 px-4 md:py-16 overflow-hidden" data-id="element-156">
      <motion.div className="max-w-md md:max-w-2xl mx-auto text-center" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      amount: 0.2
    }} data-id="element-157">
        {/* Full Colorful Card */}
        <motion.div variants={itemVariants} className="bg-gradient-to-br from-yellow-100 via-cyan-100 to-pink-100 p-5 md:p-8 rounded-2xl shadow-xl border border-yellow-300" data-id="element-158">
          <h2 className="text-sm font-bold text-red-600 uppercase tracking-wide mb-1" data-id="element-159">
            📌 TE PRESENTAMOS:
          </h2>
          <h3 className="text-xl md:text-2xl font-extrabold text-blue-900 leading-snug mb-2" data-id="element-160">
            "ESTIMULACIÓN PARA NUESTROS PEQUES DE 1 A 3 AÑOS"
          </h3>
          <p className="text-base md:text-lg text-gray-800 leading-relaxed mb-4" data-id="element-161">
            Un libro digital en PDF con más de{' '}
            <span className="font-bold text-blue-800" data-id="element-162">
              260 actividades listas para imprimir
            </span>
            , diseñadas especialmente para desarrollar el cerebro de tu peque a
            través del juego.
          </p>

          {/* Product Image */}
          <img src="https://cdn.magicpatterns.com/uploads/qXz5EpZcRbeZsThu6HJfWT/Imagen-de-WhatsApp-2025-04-29-a-las-21.40.32_f620f521-1.jpg" alt="Portada Actividades para la Inteligencia" className="w-full max-w-full rounded-xl shadow-md mb-4" data-id="element-163" />

          {/* Review Stars */}
          <img src="https://cdn.magicpatterns.com/uploads/pEk6eYbRuWAXzQz7zicke9/Evaluacion-general-de-Educando-Peques-¡Excelente-4.9-5-1.245-1.png" alt="Reseñas 5 estrellas de padres y madres felices" className="mx-auto max-w-[280px] md:max-w-[340px] h-auto" data-id="element-164" />
        </motion.div>
      </motion.div>
    </section>;
}